import React from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import DesignNDetail from "./DesignNDetail"
import OrderDetails from "./OrderDetails"

import Material from "./Material"

export default function Index(props) {
  const {
    config: { data },
  } = props
  return (
    <>
      <Card>
        <CardBody>
          <OrderDetails config={props.config} />
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <Row>
            <Col xl={5} sm={8}>
              <Material data={data} />
              <DesignNDetail data={data} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  )
}
